module.exports = __webpack_public_path__ + "images/emoji/koko.3465e344664c35a5fb5b.png";